var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowcaseAddToInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#64778E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 7.125V8.25C16.3333 9.33384 16.3333 9.87576 16.2546 10.3292C15.8213 12.8252 13.6756 14.7829 10.9397 15.1782C10.4427 15.25 9.39629 15.25 8.20831 15.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29169 16.875C8.96298 16.5555 7.66669 15.7052 7.66669 15.25C7.66669 14.7948 8.96298 13.9445 9.29169 13.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaseAddToInput);
export default __webpack_public_path__ + "static/media/showcase-add-to-input.3d16255c7d19e9b7bc317e283fb9c2b0.svg";
export { ForwardRef as ReactComponent };